module.exports = __webpack_public_path__ + "img/keyboard_75.7520be56.png";